import React from 'react';
import { RouteItems } from 'routes/base';

const RouteContext = React.createContext<RouteItems | undefined>(undefined);
export default RouteContext;
